import React from "react";
import { __ } from "@wordpress/i18n";
const SetupComplete = () => {
	const handleGoToDashboard = () => {
        window.location.href = ultimate_security_ajax_obj.admin_url + 'admin.php?page=ultimate-security';
	};

    const handleExploreSettings = () => {
		window.location.href = ultimate_security_ajax_obj.admin_url + 'admin.php?page=ultimate-security#/login/active-logins/settings';
	};

	return (
        <>
		<div className="setup-complete-container d-flex align-items-center justify-content-center">
			<div className="container">
				<div className="d-flex align-items-center justify-content-center">
                    <div className="card border-0 shadow-sm mb-4" style={{width: "800px", height: "450px"}}>
                        <div className="card-body text-center pb-lg mb-lg border-bottom">
                            <div className="mb-4">
                                <h1 className="pl-heading fw-700 text-text mb-3">
                                    <span>{__("Setup Complete!", "ultimate-security")} </span>🎉
                                </h1>
                                <p className="pl-heading-2 fw-400 mb-0">
                                    {__(" What's next? Explore all features from the", "ultimate-security")}
                                    <br />
                                    {__(" \"Ultimate Security\" settings section.", "ultimate-security")}
                                </p>
                            </div>
                        </div>
                        <div className="card-body text-center pb-lg mb-lg border-bottom">
                            <p className="pl-heading-1 fw-600 mb-0">
                                {__(" We made Ultimate Security to be as easy", "ultimate-security")}
                                <br />
                                {__(" as possible to use. Explore the settings", "ultimate-security")}
                                <br />
                                {__(" page to match your requirements!", "ultimate-security")}
                            </p>
                        </div>
                        <div className="card-body text-center">
                            <button className="button button-primary" onClick={handleGoToDashboard}>
                                {__("Go to Dashboard", "ultimate-security")}
                            </button>
                        </div>
                    </div>
				</div>
			</div>
		</div>
        <div className="d-flex justify-content-center pb-lg mb-lg pt-4">
            <button className="button button-link" onClick={handleExploreSettings}>{__("Explore Settings", "ultimate-security")}</button>
        </div>
        </>
        
	);
};

export default SetupComplete;
